// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__YTpxY","checkboxCol":"Table_checkboxCol__1JqqF","emailCol":"Table_emailCol__VZGDE","actionCol":"Table_actionCol__1uMYu"};